import { render, staticRenderFns } from "./industries.vue?vue&type=template&id=4d92ecac&scoped=true&"
import script from "./industries.vue?vue&type=script&lang=js&"
export * from "./industries.vue?vue&type=script&lang=js&"
import style0 from "./industries.vue?vue&type=style&index=0&id=4d92ecac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92ecac",
  null
  
)

export default component.exports